var map = {
	"./Instagram_Glyph_Black.png": 3956,
	"./Maddie-98-min.jpg": 4706,
	"./OTK_logomark_green-cream.png": 1307,
	"./OTK_logomark_lightgreen.png": 2122,
	"./OTK_wordmark_horiz_green.png": 3664,
	"./amish-dinner-rolls.jpg": 1939,
	"./apple-cinnamon-babka.jpg": 6427,
	"./brown-sugar-cinnamon-oatmeal-sourdough.jpg": 1409,
	"./buckwheat-chocolate-cookies.jpg": 8710,
	"./chocolate-babka.jpeg": 8262,
	"./chocolate-chunk-sourdough.jpg": 1410,
	"./chocolate-croissants.jpg": 4427,
	"./cinnamon-roll.jpg": 9484,
	"./cranberry-pecan-sourdough.jpg": 7512,
	"./croissant-sourdough.jpg": 8100,
	"./croissant.jpg": 4707,
	"./cutting-sourdough-country-loaf - vertical.jpg": 7321,
	"./cutting-sourdough-country-loaf.jpg": 9990,
	"./english-muffins.jpg": 8310,
	"./macarons.jpg": 3229,
	"./madelyn-headshot.jpg": 3720,
	"./madelyn-in-kitchen-with-country-loaf.jpg": 3683,
	"./mason-jar-with-flour.jpg": 8399,
	"./pumpkin-sourdough-country-loaf.jpg": 3154,
	"./sourdough-bagels.jpg": 2798,
	"./sourdough-baguette.jpeg": 5140,
	"./sourdough-brioche.jpeg": 9679,
	"./sourdough-burger-buns.jpg": 6450,
	"./sourdough-country-loaf - order.jpg": 7014,
	"./sourdough-country-loaf-2.jpg": 1934,
	"./sourdough-country-loaf.jpg": 6519,
	"./sourdough-coutry-loaves.JPG": 2442,
	"./sourdough-pizza-crust.jpg": 1244,
	"./sourdough-pretzels.jpeg": 1856,
	"./sourdough-sandwich-loaf.jpg": 2694
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3907;